import { render, staticRenderFns } from "./HeaderPayment.vue?vue&type=template&id=339f2d70&"
import script from "./HeaderPayment.vue?vue&type=script&lang=js&"
export * from "./HeaderPayment.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports